import { useState } from "react";

import { useField } from "formik";

import { User } from "components/elements";
import { Label, ValidationBadge } from "components/form";
import { UsersModal } from "components/modals";
import { FieldProps } from "types/form";
import { getFieldTestId } from "utils/formik";

import { createMixedValidator } from "./fieldUtils";
import styles from "./UserField.scss";

type UserData = {
  id: string;
  isUnknown: boolean;
  givenName: string;
  familyName: string;
};

interface UserFieldProps extends FieldProps {
  roleFilter: string;
}

export function UserField(props: UserFieldProps) {
  const {
    name,
    label,
    required = false,
    roleFilter,
    tooltip,
    dataTestId,
  } = props;

  const [field, meta, { setValue }] = useField({
    ...props,
    type: "text",
    validate: createMixedValidator(name, required),
  });
  const [open, setOpen] = useState(false);
  const testId = dataTestId || getFieldTestId(name);

  function handleUserSelect(user: UserData) {
    setValue(user.id);
    setOpen(false);
  }

  return (
    <div className={styles.wrapper} data-test-id={testId}>
      <Label
        required={required}
        text={label}
        tooltip={tooltip}
        dataTestId={`${testId}-label`}
      />
      <User
        className={styles.input}
        userId={field.value}
        onClick={() => setOpen(true)}
        requiredRoles={[roleFilter]}
      />
      <UsersModal
        initialSelectedUserId={field.value}
        isOpen={open}
        roleFilter={roleFilter}
        dataTestId={`${testId}-modal`}
        onClose={() => setOpen(false)}
        onUserSelect={handleUserSelect}
      />
      <ValidationBadge
        error={meta.error}
        touched={true}
        dataTestId={`${testId}-validation-badge`}
      />
    </div>
  );
}
